import request from "@/utils/request";

// 月度列表
export function getTaxProvisionRecordApi(data) {
  return request({
    url: `/fmsapi/TaxProvisionRecord/GetTaxReportList`,
    method: "post",
    data,
  });
}

// 明细
export function getTaxDetailApi(data) {
  return request({
    url: `/fmsapi/TaxProvisionRecord/GetDetailTaxList`,
    method: "post",
    data,
  });
}

// 明细
export function getDetailLastOneTaxListApi(data) {
  return request({
    url: `/fmsapi/TaxProvisionRecord/GetDetailLastOneTaxList`,
    method: "post",
    data,
  });
}

// 明细
export function getTaxReportIsendsApi(data) {
  return request({
    url: `/fmsapi/TaxProvisionRecord/GetTaxReportIsends`,
    method: "post",
    data,
  });
}

// 明细
export function getTaxReportIsendApi(data) {
  return request({
    url: `/fmsapi/TaxProvisionRecord/GetTaxReportIsend`,
    method: "post",
    data,
  });
}

// 结转
export function jieZhuanDetailApi(data) {
  return request({
    url: `/fmsapi/TaxProvisionRecord/JieZhuanDetail`,
    method: "post",
    data,
  });
}
